<template>
  <div class="audit--activities">
    <Timeline pending>
      <TimelineItem v-for="(activities, date) in activitiesByDates" :key="date">
        <p class="time">{{ date }}</p>
        <p class="content">
          <div class="description-content" v-for="ac in activities" :key="ac.id">
            <div style="color: #808695; font-size: 90%;">
              <span v-if="ac.auditable_type === 'bom'">BOM header</span>
              <span v-else>{{ ac.auditable_type === 'bom_item' ? 'Item' : 'Alternate item' }}</span>
              {{ ac.event }} at {{ moment(ac.created_at).format('HH:mm:ss') }} by {{ ac.user.name }}.
            </div>
            <div :data-model-id="ac.auditable_id">
              <b v-if="ac.auditable">{{ ac.auditable.mpn || '' }} {{ ac.auditable.name }} {{ ac.auditable.part_number || '' }}</b>
              <div style="font-size: 90%; margin-top: 4px;">
                <strike v-if="ac.event === 'deleted'">
                  {{ ac.old_values.mpn || '' }}
                  {{ ac.old_values.chinese_name || ac.new_values.part_alias }}
                </strike>
                <div v-else-if="ac.event === 'updated' && Object.keys(ac.new_values).length > 0">
                  <p v-for="(v, p) in ac.new_values" :key="p">
                    <Icon v-if="ac.auditable_type === 'bom' && p === 'version'" type="md-flag" color="#5cadff" style="margin-left: -16px;" />
                    {{ $t(`bom_tool.edit.map_col.${p}`) }}:
                    {{ v }}
                    <strike><i>{{ ac.old_values[p] }}</i></strike>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </p>
      </TimelineItem>
    </Timeline>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'BOMChangeAudits',
  props: {
    bomId: Number
  },
  methods: {
    ...mapActions(['loadAuditsByTags']),
    moment,
    loadAudits () {
      // comma separated tags, such as, ?tags=bom:123,version:1.0.0
      this.loadAuditsByTags(`bom:${this.bomId}`).then((resp) => {
        this.audits = resp.data.data
      })
    }
  },
  computed: {
    activitiesByDates () {
      return _.groupBy(this.audits, activity => {
        return this.moment(activity.created_at).format('YYYY-MM-DD')
      })
    }
  },
  data () {
    return {
      audits: []
    }
  },
  mounted () {
    this.loadAudits()
  },
  watch: {
    bomId () {
      this.loadAudits()
    }
  }
}
</script>
<style lang="less">
.description-content {
  padding: 4px 0;
}
.description-content:hover {
  background-color: #ccc;
}
</style>
